import { RESTError } from "../core/RESTError";

export class NoRestMethodError extends RESTError {
  static readonly originException = "/SNP/CX_SW01_NO_REST_METHOD";
}
